import axios from 'axios';

export const HTTPDSP = axios.create({
  baseURL: `https://www.poetry-eyes.com/DSPAPIs/APIs/`
})
